import {
  Autocomplete,
  Box,
  createFilterOptions,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import API_CONSTRUCTOR from "../../models/api-model";
import PropertyAPIs from "../../models/property";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HouseIcon from "@mui/icons-material/House";
import { debounce } from "lodash";
const apiModel = API_CONSTRUCTOR("https://api.propertyreach.com");
const propertyApi = new PropertyAPIs(apiModel);

export const AutoCompleteAddress = ({ onChange }) => {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleChange = (_, value, reason) => {
    if (reason === "input") {
      setQuery(value);
    }
  };

  const filterOptions = createFilterOptions({
    stringify: (option) => option.label,
  });

  useEffect(() => {
    if (query.length > 0) {
      setLoading(true);
      propertyApi
        .getSuggestions(query)
        .then((result) => {
          let suggestions = result.suggestions || [];
          setOptions(suggestions);
        })
        .catch((error) => {
          console.error("Error fetching address suggestions:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setOptions([]);
    }
  }, [query]);

  return (
    <Autocomplete
      filterOptions={filterOptions}
      noOptionsText={loading ? "Loading..." : "No options found"}
      onChange={(_, value) => onChange(value)}
      onInputChange={debounce(handleChange, 500)}
      options={options}
      renderInput={(props) => <TextField {...props} label="Enter address" />}
      renderOption={(params, option) => {
        const { propertyId = "" } = option;
        return (
          <Box {...params} key={option.id}>
            {propertyId ? <HouseIcon /> : <LocationOnIcon />}
            <Typography ml={2}>{option.label}</Typography>
          </Box>
        );
      }}
      style={{ width: "50rem", maxWidth: "calc(80% - 60px)" }}
    />
  );
};

export default AutoCompleteAddress;
